import { render, staticRenderFns } from "./EndCard.vue?vue&type=template&id=078ac8f8&scoped=true"
import script from "./EndCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EndCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EndCard.vue?vue&type=style&index=0&id=078ac8f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078ac8f8",
  null
  
)

export default component.exports